import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { Creator } from '@/types';

// Lista de leads con appeal_status = pending_review. Incluye `expand:
// collector` para que la UI pueda mostrar nombre/foto/account_status del
// collector que apeló (relevante para detectar apelaciones cuyo owner
// luego se baneó / desactivó).
export function useAiAppeals() {
  return useQuery({
    queryKey: ['ai-appeals'],
    queryFn: async () =>
      pb.collection('leads').getList<Creator>(1, 100, {
        filter:
          'appeal_status = "pending_review" && deleted_at = "" && is_void = false',
        sort: 'appeal_created_at',
        expand: 'collector',
      }),
  });
}
